<div class="alert-loading">
  <div class="alert-loading-content">
    <img src="assets/spinner-default.svg" />
  </div>
</div>
